// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://rbygsrhjrwcozoikvnbw.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJieWdzcmhqcndjb3pvaWt2bmJ3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDY5MzkzNjIsImV4cCI6MjA2MjUxNTM2Mn0.t4Zg3WDW9ID3ykxxjG5imzadOqKvcDYTGFAABPlkRI0";

/** Supabase anon key – used by the widget script so Edge Function accepts the request (widget-data still validates custom token). */
export const SUPABASE_ANON_KEY = SUPABASE_PUBLISHABLE_KEY;

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);